export const IS_LEGACY_DOMAIN =
  typeof window !== 'undefined' &&
  (window.location.hostname.endsWith('oinglab-korean.com') ||
    (process.env.NODE_ENV === 'development' &&
      localStorage.getItem('dev:legacy') === '1'));

export const NEW_DOMAIN = 'https://www.ko-ready.com';

// 홈 상단 탭 "For Creator" 가 보내는 곳 — Koready Skills 크리에이터 랜딩
export const SKILLS_CREATOR_LANDING_URL =
  'https://skills.ko-ready.com/creators/apply';

export const toNewDomain = (path) =>
  `${NEW_DOMAIN}${path ?? window.location.pathname + window.location.search}`;

// 2days 파일럿 신청 완료 화면의 보조 CTA — Koready Skills 커리어 자가진단
export const SKILLS_SELF_CHECK_URL = 'https://skills.ko-ready.com/career-report';
